import { render } from "./ExpertStatisticsQueueComparator.vue?vue&type=template&id=4e16510d"
import script from "./ExpertStatisticsQueueComparator.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsQueueComparator.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__